import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class Nominee extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "description", Model.attribute('description'));
    _defineProperty(this, "slug", Model.attribute('slug'));
    _defineProperty(this, "imageUrl", Model.attribute('imageUrl'));
    _defineProperty(this, "url", Model.attribute('url'));
    _defineProperty(this, "metadata", Model.attribute('metadata'));
    _defineProperty(this, "sortOrder", Model.attribute('sortOrder'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "category", Model.hasOne('category'));
    _defineProperty(this, "voteCount", Model.attribute('voteCount'));
    _defineProperty(this, "votePercentage", Model.attribute('votePercentage'));
    _defineProperty(this, "realVoteCount", Model.attribute('realVoteCount'));
    _defineProperty(this, "voteAdjustment", Model.attribute('voteAdjustment'));
    _defineProperty(this, "rank", Model.attribute('rank'));
    _defineProperty(this, "isWinner", Model.attribute('isWinner'));
    _defineProperty(this, "isRunnerUp", Model.attribute('isRunnerUp'));
    _defineProperty(this, "isThirdPlace", Model.attribute('isThirdPlace'));
  }
}
flarum.reg.add('huseyinfiliz-awards', 'common/models/Nominee', Nominee);